import React,{Fragment,useEffect} from 'react';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import {isMobile} from 'react-device-detect';
import AmdocsIcon from '../assets/img/a-icon.svg';
import AmdocsIconRev from '../assets/img/a-icon-rev.svg';
import Expanded from './Expanded';

const Content = ({children,isExtraOpen,setIsExtraOpen,noTab,preAns}) => {


    const openExtra = () => {
        setIsExtraOpen(!isExtraOpen);   
    }


    return(
        <Fragment>
            {noTab ?
            <Fragment>
                 <TheContent className="half" initial={isMobile ? {opacity:0} : {y:'100%'}} animate={isMobile ? {opacity:1,transition:{duration:.5}} : {y:0,transition:{duration:1}}} exit={isMobile ? {opacity:1,transition:{duration:.5}} : {y:'-100%',transition:{duration:1}}}>
                    <ALogo  />
                    {children}
                </TheContent>
            </Fragment>
            :
            <Fragment>
                 <TheContent  className={isExtraOpen ? 'open' : null} initial={isMobile ? {opacity:0} : {y:'100%'}} animate={isMobile ? {opacity:1,transition:{duration:.5}} : {y:0,transition:{duration:1}}} exit={isMobile ? {opacity:1,transition:{duration:.5}} : {y:'-100%',transition:{duration:1}}}>
                    <ALogo className="rev" />
                    {children}
                    <Pullout initial={{opacity:0}} animate={{opacity:1,transition:{duration:1}}} exit={{opacity:0,transition:{duration:1}}} className={preAns ? 'hidden' : null}  onClick={openExtra}>how Amdocs can help</Pullout>
                </TheContent>
            </Fragment>
            }
        </Fragment>
    )
}

const TheContent = styled(motion.div)`
width: 70%;
height: 100%;
background: #fff;
position: relative;
padding: 3em;
/* font-size: 2vmin; */
color: #333147;
overflow-y: auto;
overflow-x: hidden;
padding-bottom: 80px;

&.open{
  /* background: #333147;
  transition-delay: 1s; */
  overflow: hidden !important;
}

@media (max-width: 1060px) {
    width: 100%;
    height: 100vh;
    padding: 1em;
    justify-content: flex-start;
}

&.half{
    width: 50%;
    background: #333147;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8em;

    @media (max-width: 1060px) {
    width: 100%;
    padding: 1em;
    justify-content: flex-start;
    position: static;
}

}

p{
    margin: 10px 0; 
    font-family: 'MarkPro-Light';
    font-size: 18px;
    width: 100%;
}
`;

const Pullout = styled(motion.div)`
    /* background: #333147; */
    /* background: rgb(234,179,48);
    background: linear-gradient(0deg, rgba(234,179,48,1) 0%, rgba(213,102,95,1) 50%, rgba(202,0,136,1) 100%); */
    background: rgb(234,179,48);
    background: linear-gradient(90deg,rgba(234,179,48,1) 0%,rgba(213,102,95,1) 50%,rgba(202,0,136,1) 100%);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    /* top: 50%; */
    top: 100px;
    right: 0;
    /* writing-mode: tb-rl; */
    /* transform: translateY(-50%) rotate(-180deg); */
    font-size: 22px;
    /* width: 40px;
    height: 140px; */
    padding: 20px;
    text-align: center;
    /* writing-mode: vertical-rl; */
    text-orientation: mixed;
    cursor: pointer;
    line-height: 1;
    font-family: 'MarkPro-Bold';

    &.hidden{
        display: none;
    }

    @media (max-width: 1060px) {
        background: rgb(234,179,48);
        background: linear-gradient(90deg, rgba(234,179,48,1) 0%, rgba(213,102,95,1) 50%, rgba(202,0,136,1) 100%);
        top: 0;
        bottom: unset;
        width: 100%;
        writing-mode: unset;
        margin-bottom: 30px;
        transform: translate(0)  rotate(0deg);

        
    }
`;

const ExpandedContent = styled.div`
    display: flex;
    /* justify-content: center;
    align-items: center; */
    flex-direction: column;
    background: #333147;
    color: #fff;
    height: 100%;
    width: 70%;
    position: absolute;
    top: 0;
    right: 0; 
    bottom: 0;
    padding: 3em;
    transition: all .5s ease;
    overflow-x: hidden;
    z-index: 999999;

    &.close{
        transform: translateX(100%);
        transition: all .5s ease;
        overflow-x: hidden;
    }

    div{
        &:first-of-type{
            margin-left: 60px;
        }
    }

    p{
        margin: 20px 0;
    }

    h1{
        font-family: 'MarkPro-Black';
        font-size: 3em;
    }

    ul{
        li{
            margin: 10px 0;
        }
    }
`;

const ClosePullout = styled.div`
   background: rgb(234,179,48);
    background: linear-gradient(180deg, rgba(234,179,48,1) 0%, rgba(213,102,95,1) 50%, rgba(202,0,136,1) 100%);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    /* width: 40px;
    height: 140px; */
    padding: 20px;
    text-align: center;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    cursor: pointer;
    font-family: 'MarkPro-Bold';
    line-height: 1;
`;


const ALogo = styled.div`
    display: block;
    position: absolute;
    background: url(${AmdocsIcon}) no-repeat center center;
    top: 20px;
    right: 20px;
    width: 50px;
    height: 50px;

    @media (max-width: 1060px) {
        top: 80px;
        display: none;
    }


   &.rev{
        background: url(${AmdocsIconRev}) no-repeat center center;

    }

`;

export default Content;

